import React from 'react'
import {Field} from 'formik'
import {InputText, TextArea} from '@/components/form'
import {Card} from '@/components/Card'

const GeneralCard = () => {
  return (
    <Card
      title='General'
      collapsable={true}
      id='general'
      className="card mb-5 mb-xl-8"
    >
      <div className={'row'}>
        <div className="col-6 mb-10">
          <Field
            name="name"
            type="text"
            component={InputText}
            label="Product Name"
            description="A product name is required and recommended to be unique."
            required={true}
          />
        </div>
        <div className="col-6 mb-10">
          <Field
            name="sku"
            type="text"
            component={InputText}
            label="SKU"
            placeholder="SKU reference"
            description="Enter the product SKU."
            required={true}
          />
        </div>
      </div>
      <div className="mb-10">
          <Field
            name="subtitle"
            type="text"
            component={InputText}
            label="Product Subtitle"
            description="A product subtitle (h2)."
            required={true}
          />

        <Field
          name="description"
          type="text"
          component={TextArea}
          rows={10}
          className='form-control resize-none min-h-25px'
          label="Description"
          placeholder="Type your text here ..."
          description="Set a description to the product for better visibility."
          required={true}
        />
      </div>
    </Card>
  )
}

export {GeneralCard}
